import "./web-components/EventBusComponent"

import "./web-components/common/AddressComponent"
import "./web-components/common/EncasingParserComponent"
import "./web-components/common/GameNameParserComponent"
import "./web-components/common/ImageComponent"
import "./web-components/common/ModalComponent"
import "./web-components/common/PaypalButtonComponent"
import "./web-components/common/PdfGeneratorComponent"
import "./web-components/common/QuestionTooltipComponent"
import "./web-components/common/SuccessFlashMessageComponent"

import "./web-components/frontoffice/SubmissionListAdditionalServicesComponent";
import "./web-components/frontoffice/SubmissionListAddressComponent"
import "./web-components/frontoffice/SubmissionListAddressesModalComponent"
import "./web-components/frontoffice/SubmissionListBlockModalComponent";
import "./web-components/frontoffice/SubmissionListConfirmationComponent";
import "./web-components/frontoffice/SubmissionListContentComponent";
import "./web-components/frontoffice/SubmissionListDeferredPaymentModalComponent";
import "./web-components/frontoffice/SubmissionListPricingSummaryModalComponent"
import "./web-components/frontoffice/SubmissionListFormComponent"
import "./web-components/frontoffice/SubmissionListHeaderComponent";
import "./web-components/frontoffice/SubmissionListTypeComponent";
import "./web-components/frontoffice/SubmissionListPaymentComponent";
import "./web-components/frontoffice/SubmissionListSummaryComponent";
import "./web-components/frontoffice/SupplementaryItemFormComponent"